import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, getApiErrorMessage } from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("verifying");
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      if (!token) { setState("error"); setError("Missing token"); return; }
      try { await api.post("/auth/verify-email", { token }); setState("ok"); }
      catch (e) { setState("error"); setError(getApiErrorMessage(e)); }
    })();
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F5F2] px-6 py-10">
      <div className="w-full max-w-md bg-white border border-[#E8E6E1] rounded-3xl p-8 lg:p-10 shadow-[0_8px_30px_rgb(0,0,0,0.04)] text-center" data-testid="verify-email-page">
        {state === "verifying" && (
          <div>
            <div className="text-sm text-[#5C6660]">Verifying your email…</div>
          </div>
        )}
        {state === "ok" && (
          <div data-testid="verify-success">
            <div className="w-14 h-14 rounded-full bg-[#E6F0EB] flex items-center justify-center mx-auto mb-4">
              <CheckCircle2 size={26} className="text-[#2A4D3E]" />
            </div>
            <h1 className="font-heading text-2xl font-semibold text-[#2A332C]">Email verified</h1>
            <p className="text-sm text-[#5C6660] mt-2 mb-6">Your account is fully activated.</p>
            <Link to="/login" className="inline-block bg-[#2A4D3E] text-white rounded-full px-6 py-3 text-sm font-medium hover:bg-[#1E3B2F]">Continue to sign in</Link>
          </div>
        )}
        {state === "error" && (
          <div data-testid="verify-error">
            <div className="w-14 h-14 rounded-full bg-[#FDEDEC] flex items-center justify-center mx-auto mb-4">
              <XCircle size={26} className="text-[#C0392B]" />
            </div>
            <h1 className="font-heading text-2xl font-semibold text-[#2A332C]">Verification failed</h1>
            <p className="text-sm text-[#5C6660] mt-2 mb-6">{error || "The link is invalid or expired."}</p>
            <Link to="/login" className="inline-block text-[#2A4D3E] font-semibold text-sm hover:underline">Back to sign in</Link>
          </div>
        )}
      </div>
    </div>
  );
}
